const listeners = {
  animal: 'cowmed-animal',
  batch: 'cowmed-batch',
  ccom: 'cowmed-ccom',
  ccommap: 'cowmed-ccommap',
  cenvmap: 'cowmed-cenvmap',
  close_release_note: 'cowmed-close-release-notes',
  company: 'cowmed-company',
  company_project: 'cowmed-company-project',
  ctech: 'cowmed-ctech',
  datagrid: 'cowmed-datagrid',
  errorboundary: 'error-boundary',
  farm: 'cowmed-farm',
  list: 'cowmed-list',
  listbuilder: 'cowmed-listbuilder',
  pagebuilder: 'cowmed-pagebuilder',
  production: 'cowmed-production',
  protocol: 'cowmed-protocol',
  sanitary_protocol: 'cowmed-sanitary-protocol',
  semen: 'cowmed-semen',
  thi: 'cowmed-thi',
  vic_token_usage: 'cowmed-vic-token-usage',
}

export { listeners }
